export default __webpack_public_path__ + "static/media/251063.1f288f6a.webp";